// import React, { useState, useEffect } from "react";
// import { Input, FormFeedback, Tooltip } from "reactstrap";

// const WeightInput = ({
//     label = "Enter Weight",
//     required = false,
//     layout = "below", // Default layout
//     minValue,
//     maxValue,
//     unitOptions = ["kg", "gm", "lb", "oz"],
//     defaultUnit = "kg",
//     placeholder = "Enter weight",
//     requiredErrorMessage = "Weight is required.",
//     invalidErrorMessage = "Please enter a valid weight.",
//     rangeErrorMessage = `Weight must be between {min} and {max} {unit}.`,
//     helpText = "",
//     showHelp = false,
//     validateTrigger, // Trigger for validation on form submission
//     value,
//     onChange,
// }) => {
//     const [weight, setWeight] = useState(value || "");
//     const [selectedUnit, setSelectedUnit] = useState(defaultUnit);
//     const [errors, setErrors] = useState({});
//     const [tooltipOpen, setTooltipOpen] = useState(false);

//     useEffect(() => {
//         if (validateTrigger) {
//             validateWeight(weight);
//         }
//     }, [validateTrigger, weight]);

//     const validateWeight = (value) => {
//         const newErrors = {};
//         const numValue = parseFloat(value);

//         // Required validation
//         if (required && !value) {
//             newErrors.required = requiredErrorMessage;
//         } else if (isNaN(numValue) || numValue < 0) {
//             newErrors.invalid = invalidErrorMessage;
//         } else if ((minValue !== undefined && numValue < minValue) || (maxValue !== undefined && numValue > maxValue)) {
//             newErrors.range = rangeErrorMessage
//                 .replace(/{min}/g, minValue)
//                 .replace(/{max}/g, maxValue)
//                 .replace(/{unit}/g, selectedUnit);
//         }

//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };

//     const handleWeightChange = (e) => {
//         const value = e.target.value; // Get the input value
//         setWeight(value); // Set the local state
//         onChange(value); // Pass it up to the parent component
//         validateWeight(value); // Validate the value
//     };

//     const handleUnitChange = (e) => {
//         setSelectedUnit(e.target.value);
//     };

//     const handleBlur = (e) => {
//         validateWeight(e.target.value);
//     };

//     return (
//         <div className={layout === "inline" ? "d-flex align-items-center" : ""}>
//             <label className="d-flex" style={{ width: layout === "inline" ? "20%" : "100%" }}>
//                 {label}
//                 {required && <span className="text-danger ml-1">*</span>}
//                 {showHelp && (
//                     <span id="helpTooltip" className="px-2">
//                         <i
//                             className="ri-question-line"
//                             style={{ cursor: 'pointer', fontSize: '16px' }}
//                         ></i>
//                     </span>
//                 )}
//             </label>
//             {showHelp && (
//                 <Tooltip
//                     placement="right"
//                     isOpen={tooltipOpen}
//                     target="helpTooltip"
//                     toggle={() => setTooltipOpen(!tooltipOpen)}
//                 >
//                     {helpText}
//                 </Tooltip>
//             )}
//             <div className="input-group w-100">
//                 <Input
//                     type="number"
//                     value={weight}
//                     onChange={handleWeightChange}
//                     onBlur={handleBlur}
//                     placeholder={placeholder}
//                     invalid={!!errors.required || !!errors.invalid || !!errors.range}
//                     style={{ flex: "10" }} // Light grey background for input
//                 />
//                 <select
//                     value={selectedUnit}
//                     onChange={handleUnitChange}
//                     className="form-select"
//                     style={{ flex: "1", backgroundColor: '#f0f0f0' }} // Light grey background for dropdown
//                 >
//                     {unitOptions.map((unit) => (
//                         <option key={unit} value={unit}>
//                             {unit}
//                         </option>
//                     ))}
//                 </select>
//             </div>

//             {errors.required && (
//                 <div style={{ color: '#f06548', fontSize: '0.875em', marginTop: '0.25rem' }}>
//                     {errors.required}
//                 </div>
//             )}
//             {errors.invalid && (
//                 <div style={{ color: '#f06548', fontSize: '0.875em', marginTop: '0.25rem' }}>
//                     {errors.invalid}
//                 </div>
//             )}
//             {errors.range && (
//                 <div style={{ color: '#f06548', fontSize: '0.875em', marginTop: '0.25rem' }}>
//                     {errors.range}
//                 </div>
//             )}
//         </div>
//     );
// };

// export default WeightInput;












import React, { useState, useEffect } from "react";
import { Input, FormFeedback, Tooltip } from "reactstrap";

const WeightInput = ({
    label = "Weight",
    required = false,
    layout = "below", // Default layout
    minValue,
    maxValue,
    unitOptions = ["Kg", "Gm", "Lb", "Oz"],
    defaultUnit = "Kg",
    placeholder = "Enter weight",
    requiredErrorMessage = "Weight is required.",
    invalidErrorMessage = "Please enter a valid weight.",
    rangeErrorMessage = `Weight must be between {min} and {max} {unit}.`,
    helpText = "",
    showHelp = false,
    validateTrigger, // Trigger for validation on form submission
    value,
    onChange,
}) => {
    const [weight, setWeight] = useState(value || "");
    const [selectedUnit, setSelectedUnit] = useState(defaultUnit);
    const [errors, setErrors] = useState({});
    const [tooltipOpen, setTooltipOpen] = useState(false);

    // Sync weight with Formik value prop
    useEffect(() => {
        setWeight(value);
    }, [value]);

    useEffect(() => {
        if (validateTrigger) {
            validateWeight(weight);
        }
    }, [validateTrigger, weight]);

    const validateWeight = (value) => {
        const newErrors = {};
        const numValue = parseFloat(value);

        // Skip validation if required is false and the value is empty
        if (required && !value) {
            newErrors.required = requiredErrorMessage;
        } else if (isNaN(numValue) || numValue < 0) {
            newErrors.invalid = invalidErrorMessage;
        } else if ((minValue !== undefined && numValue < minValue) || (maxValue !== undefined && numValue > maxValue)) {
            newErrors.range = rangeErrorMessage
                .replace(/{min}/g, minValue)
                .replace(/{max}/g, maxValue)
                .replace(/{unit}/g, selectedUnit);
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleWeightChange = (e) => {
        const value = e.target.value; // Get the input value
        setWeight(value); // Set the local state
        onChange("weight", value); // Pass it up to Formik
        validateWeight(value); // Validate the value
    };

    const handleUnitChange = (e) => {
        const newUnit = e.target.value; // Get the selected unit
        setSelectedUnit(newUnit); // Update local state
        onChange("weightOptions", newUnit); // Pass it up to Formik
    };

    const handleBlur = (e) => {
        // Only validate on blur if required
        if (required) {
            validateWeight(e.target.value);
        }
    };

    return (
        <>
        <div className={layout === "inline" ? "d-flex align-items-center" : ""}>
            <label className="d-flex" style={{ width: layout === "inline" ? "20%" : "100%" }}>
                {label}
                {required && <span className="text-danger ml-1">*</span>}
                {showHelp && (
                    <span id="helpTooltip" className="px-2">
                        <i className="ri-question-line" style={{ cursor: "pointer", fontSize: "16px" }}></i>
                    </span>
                )}
            </label>
            {showHelp && (
                <Tooltip
                    placement="right"
                    isOpen={tooltipOpen}
                    target="helpTooltip"
                    toggle={() => setTooltipOpen(!tooltipOpen)}
                >
                    {helpText}
                </Tooltip>
            )}
            <div className="w-100">
                <div className="input-group w-100">
                    <Input
                        type="number"
                        value={weight}
                        onChange={handleWeightChange}
                        onBlur={handleBlur}
                        placeholder={placeholder}
                        invalid={!!errors.required || !!errors.invalid || !!errors.range}
                        style={{ flex: "10" }} // Light grey background for input
                    />
                    <select
    value={selectedUnit || defaultUnit}
    onChange={handleUnitChange}
    className="form-select no-focus-outline"
    style={{ flex: "1", backgroundColor: "#f0f0f0" }}
>
    {unitOptions.map((unit) => (
        <option key={unit} value={unit}>
            {unit}
        </option>
    ))}
</select>

                </div>
                {errors.required && (
                    <div style={{ color: "#f06548", fontSize: "0.875em", marginTop: "0.25rem" }}>
                        {errors.required}
                    </div>
                )}
                {errors.invalid && (
                    <div style={{ color: "#f06548", fontSize: "0.875em", marginTop: "0.25rem" }}>
                        {errors.invalid}
                    </div>
                )}
                {errors.range && (
                    <div style={{ color: "#f06548", fontSize: "0.875em", marginTop: "0.25rem" }}>
                        {errors.range}
                    </div>
                )}
            </div>
        </div>
        </>
    );
};

export default WeightInput;
